export const GET_BASKET_COUNT_SUCCESS = 'header/GET_BASKET_COUNT_SUCCESS';

const onSuccess = count => ({
  type: GET_BASKET_COUNT_SUCCESS,
  payload: { basketCount: count === '' ? 0 : count },
});

const onFailure = () => ({
  type: GET_BASKET_COUNT_SUCCESS,
  payload: { basketCount: 0 },
});

export const getBasketCountAction = (baseUrl = '') => {
  return {
    payload: {
      url: `${baseUrl}/cart/count`,
      method: 'GET',
      withCredentials: true,
      onSuccess,
      onFailure,
    },
  };
};
